import { createSelector } from "@ngrx/store";
import { getUserModuleState, UserState } from "#login/store/reducers";
import * as fromLanguages from "../reducers/languages.reducer";

export const getLanguagesState = createSelector(
    getUserModuleState,
    (state: UserState) => state.languages
);

// get the entities inside activeLanguages
export const getLanguagesEntities = createSelector(
    getLanguagesState,
    fromLanguages.getLanguagesEntities
);

// convert so our view can consume
export const getAllLanguages = createSelector(
    getLanguagesEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getLanguagesLoaded = createSelector(
    getLanguagesState,
    fromLanguages.getLanguagesLoaded
);

export const getLanguagesLoading = createSelector(
    getLanguagesState,
    fromLanguages.getLanguagesLoading
);
